import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterSelect from '../../components/FilterSelect';
import * as shortlistActions from '../../actions/shortlist';
import {
    shortlistStateKey,
    isHorseNameFilterDisabled,
    isCommonFilterDisabled,
} from '../../helpers/shortlistUtils';

class HorseFilters extends PureComponent {
    static propTypes = {
        refinement: PropTypes.shape({
            horseName: PropTypes.string,
            horseSex: PropTypes.string,
            horseAge: PropTypes.string,
        }).isRequired,
        data: PropTypes.shape({
            horseNameOptions: PropTypes.array,
            horseSexOptions: PropTypes.array,
            horseAgeOptions: PropTypes.array
        }).isRequired,
        loadHorseNameOptions: PropTypes.func.isRequired,
        loadHorseSexOptions: PropTypes.func.isRequired,
        loadHorseAgeOptions: PropTypes.func.isRequired,
        applyShortlistHorseNameFilter: PropTypes.func.isRequired,
        applyShortlistHorseSexFilter: PropTypes.func.isRequired,
        applyShortlistHorseAgeFilter: PropTypes.func.isRequired
    };

    isHorseNameFilterDisabled() {
        return isHorseNameFilterDisabled(this.props.refinement);
    }

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    handleHorseNameChange = (event) => {
        this.props.applyShortlistHorseNameFilter(event.target.value);
    };

    render() {
        const {
            refinement: {
                horseName,
                horseSex,
                horseAge,
            },
            data: {
                horseNameOptions,
                horseSexOptions,
                horseAgeOptions,
            },
            loadHorseNameOptions,
            loadHorseSexOptions,
            loadHorseAgeOptions,
            applyShortlistHorseNameFilter,
            applyShortlistHorseSexFilter,
            applyShortlistHorseAgeFilter
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Sex</span>
                    <FilterSelect
                        title="Sex"
                        disabled={this.isCommonFilterDisabled()}
                        value={horseSex}
                        options={horseSexOptions}
                        onPopoverDidOpen={loadHorseSexOptions}
                        onChange={applyShortlistHorseSexFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Age</span>
                    <FilterSelect
                        title="Age"
                        disabled={this.isCommonFilterDisabled()}
                        value={horseAge}
                        options={horseAgeOptions}
                        onPopoverDidOpen={loadHorseAgeOptions}
                        onChange={applyShortlistHorseAgeFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Name</span>
                    <FilterSelect
                        title="Name"
                        alphabet
                        showSearch
                        disabled={this.isHorseNameFilterDisabled()}
                        value={horseName}
                        options={horseNameOptions}
                        onPopoverDidOpen={loadHorseNameOptions}
                        onChange={applyShortlistHorseNameFilter}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { refinement, data } = state[shortlistStateKey];
    return {
        refinement,
        data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HorseFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/HorseFiltersShortlist.js